export default __webpack_public_path__ + "9dfc15ac682e6afe35286172777db858.svg";